/* Wishlist Hero owns account identity, storage, saves and saved-state UI.
   This bridge supplies login guidance, account launch points and old-browser review.
   It does not call paid SDK methods or implement a second wishlist database. */
(function () {
  'use strict';
  var linksReady = false, root, lastFocus, autoOpened = false;
  var boundHearts = new WeakMap(), layoutQueued = false, watchedButtons = new WeakSet();
  var heartMarkup = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
  function bindHeart(node) {
    if (!linksReady) return;
    var signature = ['id','variantid','link','image','price'].map(function (key) { return node.getAttribute('data-wlh-'+key); }).join('|');
    if (boundHearts.get(node) === signature) return;
    boundHearts.set(node,signature);
    // Native embed event: no SDK methods, second saved list or storage writes.
    document.dispatchEvent(new CustomEvent('wishlist-hero-add-to-custom-element',{detail:node}));
  }
  function builderHearts() {
    document.querySelectorAll('[data-zr-builder-card]').forEach(function (card) {
      var link = card.querySelector('.zr-builder-card__art'), select = card.querySelector('[data-zr-builder-variant]');
      if (!link || !select || !select.value || !card.dataset.productId) return;
      var url;
      try { url = new URL(link.href,location.href); } catch (error) { return; }
      if (url.origin !== location.origin || !url.pathname.includes('/products/')) return;
      var option = select.selectedOptions[0], cents = Number(option && option.dataset.priceCents);
      if (!Number.isFinite(cents) || cents < 0) return;
      var title = card.querySelector('h2'), img = link.querySelector('img');
      var node = card.querySelector('[data-zr-native-heart]');
      if (!node) {
        node = document.createElement('div');
        node.className = 'wishlist-hero-custom-button wishlisthero-floating zr-wishlist-card-heart';
        node.setAttribute('data-zr-native-heart','');
        var button = document.createElement('button'); button.type = 'button';
        button.setAttribute('data-zr-wishlist-loading','');
        button.setAttribute('aria-label','Save '+(title ? title.textContent.trim() : 'artwork')+' to your wishlist');
        button.innerHTML = heartMarkup; node.appendChild(button);
        card.insertBefore(node,card.firstChild);
      }
      url.searchParams.set('variant',select.value);
      var values = {id:card.dataset.productId,variantid:select.value,link:url.href,name:title ? title.textContent.trim() : '',price:cents / 100,image:img ? img.src : '',mode:'icon_only',view:'Collection'};
      Object.keys(values).forEach(function (key) { node.setAttribute('data-wlh-'+key,values[key]); });
    });
  }
  function matchProductButtons() {
    document.querySelectorAll('[data-zr-wishlist-product-action]').forEach(function (area) {
      var section = area.closest('.product-section');
      var cartButton = section && section.querySelector('[data-add-to-cart]');
      if (!cartButton) return;
      function measure() {
        var style = getComputedStyle(cartButton), height = cartButton.getBoundingClientRect().height;
        var values = {'height':Math.max(44,height)+'px','font-family':style.fontFamily,'font-size':style.fontSize,'font-weight':style.fontWeight,'letter-spacing':style.letterSpacing,'radius':style.borderRadius};
        Object.keys(values).forEach(function (key) {
          var prop = '--zr-wishlist-'+key;
          if (area.style.getPropertyValue(prop) !== values[key]) area.style.setProperty(prop,values[key]);
        });
      }
      measure();
      if (window.ResizeObserver && !watchedButtons.has(cartButton)) {
        watchedButtons.add(cartButton);
        var observer = new ResizeObserver(function () { if (!cartButton.isConnected) observer.disconnect(); else measure(); });
        observer.observe(cartButton);
      }
    });
  }
  function syncControls() {
    layoutQueued = false;
    builderHearts();
    document.querySelectorAll('[data-zr-native-heart]').forEach(bindHeart);
    matchProductButtons();
  }
  function queueControls() {
    if (layoutQueued) return;
    layoutQueued = true; requestAnimationFrame(syncControls);
  }
  function appReady() {
    return linksReady || !!window.WishListHero_SDK;
  }
  function loggedIn() { return root && !!root.dataset.customerId; }
  function showHelp(target) {
    if (!root) return;
    document.dispatchEvent(new CustomEvent('zr:overlay-opening',{detail:{source:'wishlist'}}));
    if (typeof root.showModal !== 'function') {
      var login = root.querySelector('a[href]');
      if (!loggedIn() && login) location.assign(login.href);
      else { root.hidden = false; root.setAttribute('open', ''); }
      return;
    }
    lastFocus = target || document.activeElement;
    root.hidden = false;
    if (!root.open) root.showModal();
    document.body.classList.add('zr-wishlist-help-open');
  }
  function closeHelp() {
    if (!root) return;
    if (typeof root.close === 'function') root.close();
    else { root.removeAttribute('open'); finishClose(); }
  }
  function finishClose() {
    root.hidden = true; document.body.classList.remove('zr-wishlist-help-open');
    if (lastFocus && lastFocus.isConnected) lastFocus.focus({preventScroll:true});
  }
  function launch() {
    if (!loggedIn() || !appReady()) { showHelp(); return; }
    closeHelp();
    // Use the vendor's documented native launch anchor, not its paid JavaScript API.
    var link = document.querySelector('[data-zr-wishlist-launch]');
    if (link) link.click();
  }
  function autoLaunch() {
    if (!root || autoOpened || new URL(location.href).searchParams.get('zr_saved') !== '1') return;
    if (loggedIn() && !appReady()) return;
    autoOpened = true; launch();
  }
  function reviewEarlierFavorites() {
    if (!loggedIn()) return;
    var items;
    try { items = JSON.parse(localStorage.getItem('zrFavorites.v1') || '[]'); } catch (error) { return; }
    if (!Array.isArray(items)) return;
    var seen = new Set();
    items = items.filter(function (item) {
      if (!item || typeof item.handle !== 'string' || !/^[a-z0-9][a-z0-9-]{0,199}$/.test(item.handle) || seen.has(item.handle)) return false;
      seen.add(item.handle); return true;
    }).slice(0,100);
    if (!items.length) return;
    document.querySelectorAll('[data-zr-browser-favorites]').forEach(function (area) {
      var list = area.querySelector('[data-zr-browser-favorites-list]'); list.replaceChildren();
      items.forEach(function (item) {
        var li = document.createElement('li'), a = document.createElement('a');
        var url = new URL(root.dataset.productsRoot + encodeURIComponent(item.handle),location.origin);
        if (url.origin !== location.origin) return;
        a.href = url.pathname; a.textContent = String(item.title || item.handle).slice(0,300);
        li.appendChild(a); list.appendChild(li);
      });
      area.hidden = false;
    });
    // Intentionally read-only: an old browser list might belong to someone else.
  }
  document.addEventListener('wishlist-hero-links-binded',function () { linksReady = true; queueControls(); autoLaunch(); });
  document.addEventListener('wishlist-hero-wishlist-sdk-ready',autoLaunch);
  // Capture before the vendor's button handlers: guests get a clear account prompt.
  window.addEventListener('click',function (event) {
    if (!root || !event.target.closest) return;
    var open = event.target.closest('[data-zr-account-wishlist-open],[data-zr-wishlist-launch]');
    var save = event.target.closest('.wishlisthero-floating,.wishlisthero-product-page-button-container,#wishlist-hero-product-page-button');
    if (!open && !save) return;
    document.dispatchEvent(new CustomEvent('zr:overlay-opening',{detail:{source:'wishlist'}}));
    if (!loggedIn() || (open && !appReady()) || event.target.closest('[data-zr-wishlist-loading]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      showHelp(open || event.target.closest('button,a'));
    }
    // Signed-in, ready clicks continue through to the app's native behavior.
  },true);
  function init() {
    root = document.querySelector('[data-zr-wishlist-help]'); if (!root) return;
    root.addEventListener('click',function (event) {
      if (event.target.closest('[data-zr-wishlist-close]')) closeHelp();
      if (event.target.closest('[data-zr-wishlist-retry]')) launch();
      if (event.target === root) {
        var rect = root.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeHelp();
      }
    });
    root.addEventListener('close',finishClose);
    reviewEarlierFavorites(); autoLaunch(); syncControls();
    document.addEventListener('zr:catalog-rendered',queueControls,true);
    document.addEventListener('change',function (event) { if (event.target.matches('[data-zr-builder-variant]')) queueControls(); });
    document.addEventListener('shopify:section:load',queueControls);
    window.addEventListener('resize',queueControls,{passive:true});
    // Observe only added/removed nodes: theme filters and the app render asynchronously.
    new MutationObserver(queueControls).observe(document.body,{childList:true,subtree:true});
    if (new URL(location.href).searchParams.get('zr_saved') === '1') {
      setTimeout(function () { if (!autoOpened) { autoOpened = true; showHelp(); } },10000);
    }
  }
  // A restored account page must refresh its Shopify and app sessions.
  window.addEventListener('pageshow',function (event) { if (event.persisted) location.reload(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
}());
